import { useQuery } from '@tanstack/react-query'

import { fetchReservationCalendar } from '@/lib/venue/reservationApi'
import type { ReservationCalendarView } from '@/lib/venue/reservationTypes'

export function reservationCalendarQueryKey(
  venueId: string,
  from: string,
  to: string,
  courtId: number | 'ALL'
) {
  return ['venue', venueId, 'reservation-calendar', from, to, courtId] as const
}

export function useVenueReservationCalendar(
  venueId: string,
  params: { from: string; to: string; courtId: number | 'ALL' }
) {
  return useQuery<ReservationCalendarView>({
    queryKey: reservationCalendarQueryKey(venueId, params.from, params.to, params.courtId),
    queryFn: () =>
      fetchReservationCalendar(venueId, {
        from: params.from,
        to: params.to,
        courtId: params.courtId === 'ALL' ? undefined : params.courtId,
      }),
  })
}
